import React from 'react';
import { Col, Container } from 'react-bootstrap';
import { TopMenu } from '../../shared';

function WebsitePolicy() {


  return (
    <>
      <TopMenu />

      <Col lg={12} className='inner-bg'>
        <Container className='middle-content'>
          <div className="page-heading">
            <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4' />
            <h4 className="fw-bold mb-2">Website Policy</h4>
            <ul className="my-topbreadcrum">
              <li>
                <a
                  href="/lms"

                >Home</a>
              </li>
              &nbsp; / &nbsp;
              <li>Website Policy</li>
            </ul>
          </div>
          <div>
            <p>This website belongs to<strong> Department of Agriculture and Farmers Welfare,</strong> Ministry of Agriculture and Farmers Welfare, Government of India.</p>
            <p>The content and the services being provided through this portal is the result of a collaborative effort of various users from <strong>Ministry of Agriculture,Govt of India,</strong>ICAR, Department of Metrology and officials of the State Governments. It is our endeavour to continue the enhancement and enrichment of this site in terms of content coverage, design and technology on a regular basis.</p>
            <p>We have put in our best efforts to ensure that all information on this portal is accessible to people with disabilities. For example, a user with visual disability can access this portal using assistive technologies, such as <strong>screen readers</strong> and <strong>screen magnifiers.</strong></p>
            <p>We also aim to be standards compliant and follow principles of usability and universal design, which should help all visitors of this portal.</p>
            <p>This portal is designed using HTML5 Transitional to meet Guidelines for Indian Government Websites and also adhere to level A of the Web Content Accessibility Guidelines (WCAG) 2.0 laid down by the World Wide Web Consortium (W3C).</p>
            <p>Part of the information in the portal is also made available through links to external Websites. External Websites are maintained by the respective departments who are responsible for making these sites accessible. DAC is working towards making its portal accessible for persons with disabilities, however currently Portable Document Format (PDF) files are not accessible. In addition, information provided in Hindi language is also not accessible. If you have any problem or suggestion regarding the accessibility of this portal, please write to Us and we will respond in a helpful manner. Do let us know the nature of the problem along with your contact information.</p>
          </div>
        </Container>
      </Col>
    </>
  );
}

export default WebsitePolicy;